/* ==========================================================================
   TEA & TALES, EIGEN GA4-METING (tt-tracking.js)

   De oude meting uit het thema van voor v2, teruggezet op 29-10-2026 en
   aangepast aan de opbouw van v2. Stuurt rechtstreeks naar Google (gtag),
   naar dezelfde property als de Shopify-integratie: G-HVG0XK7P3E.

   - Laadt gtag pas als de bezoeker analytische cookies toestaat
     (Shopify Customer Privacy API). Zonder toestemming gaat er niets weg.
   - send_page_view staat uit: paginaweergaven, winkelwagen, checkout en
     aankopen komen al via de Shopify-integratie, anders tellen ze dubbel.
   - Meet niet in de thema-editor.
   - Geen persoonsgegevens: geen namen, mailadressen of cadeauteksten.

   Events:
     tt_section_view     welke sectie gezien is + hoe lang
     tt_card_click       welk product aangeklikt, vanuit welke sectie
     tt_dead_click       klik op iets dat niet klikbaar is
     tt_geen_resultaten  filter of zoekopdracht zonder producten
     tt_cart_open        winkelwagenlade geopend, met de inhoud van de wagen
     tt_checkout_click   doorgeklikt naar afrekenen, met de inhoud van de wagen
     tt_cart_fout        in de winkelwagen leggen mislukt
     tt_erbij            product toegevoegd vanuit de suggesties in de wagen
     tt_wachtlijst       aangemeld voor voorraad, prijs of een vol evenement
     tt_vraag_open       vraag opengeklapt (productpagina, FAQ, reviews)
     tt_foto             doorgekeken naar foto 2, 3, ... op de productpagina
     tt_filter           filter aan- of uitgezet op een collectie
     tt_sorteer          sortering gekozen
     tt_taal             taal gewisseld
     tt_land             land gewisseld
     tt_cadeau           vinkje "Dit is een cadeau" aan of uit
     tt_cadeau_bericht   cadeauberichtje ingevuld (alleen dat het gebeurde)
     sticky_cart_click   knop in de meelopende koopbalk
     whatsapp_click      WhatsApp-link
     newsletter_signup   nieuwsbrief aangemeld
   ========================================================================== */
(function () {
  if (window.__ttInsights) return;
  window.__ttInsights = true;
  if (window.Shopify && window.Shopify.designMode) return;

  var GA_ID = 'G-HVG0XK7P3E';
  var wachtrij = [];
  var gestart = false;

  /* ---------------------------------------------------------------- 0
     TOESTEMMING EN GTAG
     ---------------------------------------------------------------- */
  function magMeten() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }

  function start() {
    if (gestart || !magMeten()) return;
    gestart = true;
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function () { window.dataLayer.push(arguments); };
    }
    window.gtag('consent', 'default', {
      analytics_storage: 'granted',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied'
    });
    window.gtag('js', new Date());
    window.gtag('config', GA_ID, { send_page_view: false });
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA_ID;
    document.head.appendChild(s);
    for (var i = 0; i < wachtrij.length; i++) {
      window.gtag('event', wachtrij[i][0], wachtrij[i][1]);
    }
    wachtrij = [];
  }

  function ev(naam, params) {
    params = params || {};
    params.send_to = GA_ID;
    if (gestart) {
      try { window.gtag('event', naam, params); } catch (e) {}
    } else if (wachtrij.length < 50) {
      wachtrij.push([naam, params]);
    }
  }

  function regelToestemming() {
    if (window.Shopify && window.Shopify.customerPrivacy) { start(); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err) start();
      });
    }
  }
  document.addEventListener('visitorConsentCollected', start);

  /* ---------------------------------------------------------------- hulp */
  var pad = function () { return location.pathname.slice(0, 90); };
  var kort = function (s, n) { return String(s || '').replace(/\s+/g, ' ').trim().slice(0, n || 60); };
  var mee = function (a, b) { for (var k in b) { if (Object.prototype.hasOwnProperty.call(b, k)) a[k] = b[k]; } return a; };
  var klaar = function (fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  };

  function handleVan(href) {
    return ((href || '').split('?')[0].split('#')[0].split('/products/')[1] || '').split('/')[0].slice(0, 60);
  }

  /* Bij welk product hoort dit formulier of element: eerst een productlink
     in de buurt, anders de productpagina zelf. */
  function productBij(el) {
    var p = el;
    for (var i = 0; p && i < 6; i++, p = p.parentElement) {
      var a = p.querySelector && p.querySelector('a[href*="/products/"]');
      if (a) return handleVan(a.getAttribute('href'));
    }
    if (location.pathname.indexOf('/products/') > -1) return handleVan(location.pathname);
    var id = el.querySelector && el.querySelector('[name="id"]');
    return id ? 'variant-' + id.value : '';
  }

  /* ---------------------------------------------------------------- wagen
     De inhoud van de wagen in een paar getallen. Wordt opgehaald als de
     lade opengaat of verandert, zodat hij klaarstaat bij de klik naar
     afrekenen (dan is er geen tijd meer om iets op te halen).
     ---------------------------------------------------------------- */
  var wagen = null;

  function drempel() {
    var el = document.querySelector('[data-progress][data-ship]');
    var n = el ? Number(el.getAttribute('data-ship')) : 0;
    return n > 0 ? n : 7000;
  }

  function samenvatting(c) {
    var d = drempel();
    var pre = 'nee', na = 'nee';
    (c.items || []).forEach(function (it) {
      var l = String((it.properties && it.properties.Levering) || '');
      if (/^pre-?order/i.test(l)) pre = 'ja';
      if (/^nalevering/i.test(l)) na = 'ja';
    });
    return {
      wagen_waarde: Math.round(c.total_price) / 100,
      wagen_artikelen: c.item_count,
      tot_gratis_verzending: Math.max(0, Math.round(d - c.total_price)) / 100,
      boven_drempel: c.total_price >= d ? 'ja' : 'nee',
      met_preorder: pre,
      met_nalevering: na
    };
  }

  function haalWagen() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { wagen = samenvatting(c); return wagen; })
      .catch(function () { return wagen; });
  }

  /* ---------------------------------------------------------------- 1
     SECTIE-ZICHTBAARHEID + kijktijd
     Telt pas als de helft van een sectie in beeld staat. Bij het
     verlaten gaat er een event weg met de kijktijd.
     ---------------------------------------------------------------- */
  if ('IntersectionObserver' in window) {
    var zicht = new Map();

    var sectieNaam = function (el) {
      var id = (el.id || '')
        .replace('shopify-section-', '')
        .replace(/^(sections|template)--\d+__/, '')
        .replace(/_[A-Za-z0-9]{6}$/, '');
      return (id || 'sectie').slice(0, 40);
    };

    var stuur = function (el, nu) {
      var t0 = zicht.get(el);
      if (t0 == null) return;
      zicht.delete(el);
      ev('tt_section_view', {
        sectie: sectieNaam(el),
        positie: el.__ttIdx || 0,
        kijktijd_sec: Math.round((nu - t0) / 1000),
        pagina: pad()
      });
    };

    var io = new IntersectionObserver(function (lijst) {
      var nu = Date.now();
      for (var k = 0; k < lijst.length; k++) {
        var en = lijst[k];
        if (en.isIntersecting) {
          if (!zicht.has(en.target)) zicht.set(en.target, nu);
        } else if (zicht.has(en.target)) {
          stuur(en.target, nu);
          io.unobserve(en.target);
        }
      }
    }, { threshold: 0.5 });

    klaar(function () {
      var secties = document.querySelectorAll('.shopify-section');
      for (var i = 0; i < secties.length; i++) {
        var s = secties[i];
        if (s.getBoundingClientRect().height < 40) continue;
        s.__ttIdx = i + 1;
        io.observe(s);
      }
    });

    window.addEventListener('pagehide', function () {
      var nu = Date.now();
      zicht.forEach(function (_, el) { stuur(el, nu); });
    });
  }

  /* ---------------------------------------------------------------- 2
     KLIKS, een listener voor alles
     ---------------------------------------------------------------- */
  var openKlik = 0;
  var vraagKlik = 0;

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('summary')) vraagKlik = Date.now();

    if (t.closest('a[href*="wa.me"], a[href*="whatsapp"]')) {
      ev('whatsapp_click', { pagina: pad() });
      return;
    }

    if (t.closest('.buybar button, .buybar [type="submit"]')) {
      ev('sticky_cart_click', { pagina: pad() });
      return;
    }

    /* Het openen zelf meet de lade hieronder; hier alleen onthouden dat
       het een klik was en geen automatische opening na toevoegen. */
    if (t.closest('[data-drawer="cart-drawer"]')) {
      openKlik = Date.now();
      return;
    }

    if (t.closest('[name="checkout"], a[href*="/checkout"]')) {
      ev('tt_checkout_click', mee({ pagina: pad() }, wagen || {}));
      return;
    }

    var a = t.closest('a[href*="/products/"]');
    if (a) {
      var sec = a.closest('.shopify-section');
      ev('tt_card_click', {
        product: handleVan(a.getAttribute('href')),
        sectie: sec ? (sec.id || '').slice(-24) : '',
        pagina: pad()
      });
      return;
    }

    /* Dode klik: alles wat geen link, knop, veld of bekend klikdoel is.
       De achtergrond van een lade (de dialog zelf) sluit hem, dus telt niet. */
    if (t.tagName === 'DIALOG') return;
    if (t.closest('a,button,input,select,textarea,label,summary,details,[role="button"],[role="tab"],[onclick],[data-drawer],[data-close-drawer],[data-close]')) return;
    try { if (String(window.getSelection() || '').length) return; } catch (e2) {}
    var sec2 = t.closest('.shopify-section');
    if (!sec2) return;
    var cls = (typeof t.className === 'string' && t.className.trim())
      ? '.' + t.className.trim().split(/\s+/)[0]
      : '';
    ev('tt_dead_click', {
      element: (t.tagName.toLowerCase() + cls).slice(0, 40),
      sectie: (sec2.id || '').slice(-24),
      pagina: pad()
    });
  }, true);

  /* ---------------------------------------------------------------- 3
     FORMULIEREN: nieuwsbrief, in de wagen leggen, erbij, wachtlijst evenement
     ---------------------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches) return;

    if (f.matches('.club__form') || (f.querySelector && f.querySelector('input[name="contact[tags]"][value*="newsletter"]'))) {
      ev('newsletter_signup', { method: 'onsite_form', pagina: pad() });
      return;
    }

    if (f.matches('form[action*="/apps/kaartje/wachtlijst"]')) {
      var evn = f.querySelector('[name="evenement"]');
      ev('tt_wachtlijst', { soort: 'evenement', product: kort(evn && evn.value, 60), pagina: pad() });
      return;
    }

    if (f.matches('form[data-add]')) {
      var product = productBij(f);
      if (f.closest('#cart-drawer, [data-cart-body]') || /\/cart\/?$/.test(location.pathname)) {
        ev('tt_erbij', { product: product, pagina: pad() });
      }
      /* Fout bij toevoegen: tt.js zet de melding in [data-error]. Oude melding
         eerst leegmaken, anders telt een eerdere fout opnieuw. */
      var slot = f.querySelector('[data-error]');
      if (slot) {
        slot.textContent = '';
        var kijk = function () {
          var m = kort(slot.textContent, 90);
          if (m && !slot.__ttGemeld) {
            slot.__ttGemeld = true;
            ev('tt_cart_fout', { melding: m, product: product, pagina: pad() });
          }
        };
        slot.__ttGemeld = false;
        setTimeout(kijk, 2500);
        setTimeout(kijk, 7000);
      }
    }
  }, true);

  /* ---------------------------------------------------------------- 4
     WIJZIGINGEN: filters, sortering, taal, cadeau
     ---------------------------------------------------------------- */
  var cadeauBericht = false;
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.name === 'locale_code') {
      ev('tt_taal', { van: document.documentElement.lang || '', naar: kort(t.value, 10), pagina: pad() });
      return;
    }
    if (t.name === 'country_code') {
      ev('tt_land', { naar: kort(t.value, 10), pagina: pad() });
      return;
    }
    if (t.name === 'sort_by') {
      ev('tt_sorteer', { sortering: kort(t.value, 40), pagina: pad() });
      return;
    }
    if (t.closest('#filters') && /^filter\./.test(t.name || '')) {
      var aan = (t.type === 'checkbox' || t.type === 'radio') ? (t.checked ? 'aan' : 'uit') : 'waarde';
      ev('tt_filter', {
        filter: kort(t.name.replace(/^filter\.(v|p)\.(m\.)?/, ''), 40),
        waarde: kort(t.value, 40),
        stand: aan,
        pagina: pad()
      });
      return;
    }
    if (t.matches('[data-cadeau]')) {
      ev('tt_cadeau', { stand: t.checked ? 'aan' : 'uit', pagina: pad() });
      return;
    }
    if (t.matches('[data-cadeau-tekst]') && !cadeauBericht && String(t.value).trim()) {
      cadeauBericht = true;
      ev('tt_cadeau_bericht', { pagina: pad() });
    }
  }, true);

  /* ---------------------------------------------------------------- 5
     VRAGEN OPENKLAPPEN (details, maar niet de menu's en de filtergroepen)
     Alleen als de bezoeker zelf op de vraag klikte: blokken die bij het
     laden al open staan of door het zoekveld op de FAQ opengaan tellen niet.
     ---------------------------------------------------------------- */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches('details') || !d.open) return;
    if (Date.now() - vraagKlik > 1500) return;
    if (d.matches('.nav__group, .drawer__group, [data-nav-group]') || d.closest('#filters')) return;
    var s = d.querySelector('summary');
    ev('tt_vraag_open', { vraag: kort(s ? s.textContent : '', 80), pagina: pad() });
  }, true);

  /* ---------------------------------------------------------------- 6
     DINGEN DIE PAS NA HET LADEN BESTAAN
     ---------------------------------------------------------------- */
  klaar(function () {
    regelToestemming();

    /* Lade open: zowel na een klik als automatisch na toevoegen. */
    var lade = document.querySelector('#cart-drawer dialog');
    if (lade && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (!lade.open) return;
        var bron = (Date.now() - openKlik < 1500) ? 'klik' : 'toevoegen';
        haalWagen().then(function (w) {
          ev('tt_cart_open', mee({ bron: bron, pagina: pad() }, w || {}));
        });
      }).observe(lade, { attributes: true, attributeFilter: ['open'] });

      /* Na elke wijziging in de lade vervangt tt.js de inhoud: wagen opnieuw tellen. */
      var lijf = document.querySelector('[data-cart-body]');
      if (lijf) {
        var wacht = null;
        new MutationObserver(function () {
          clearTimeout(wacht);
          wacht = setTimeout(haalWagen, 400);
        }).observe(lijf, { childList: true });
      }
    }
    /* Op de winkelwagenpagina zelf staat de wagen er meteen. */
    if (/\/cart\/?$/.test(location.pathname)) haalWagen();

    /* Wachtlijst voorraad of prijs: telt pas als de aanmelding gelukt is. */
    var vms = document.querySelectorAll('form[data-voorraad-melding]');
    for (var i = 0; i < vms.length; i++) {
      (function (f) {
        var ok = f.querySelector('[data-vm-klaar]');
        if (!ok || !('MutationObserver' in window)) return;
        var gemeld = false;
        new MutationObserver(function () {
          if (gemeld || ok.hidden) return;
          gemeld = true;
          var soort = f.querySelector('[name="soort"]');
          var h = f.querySelector('[name="handle"]');
          ev('tt_wachtlijst', {
            soort: kort(soort && soort.value, 20) || 'voorraad',
            product: kort(h && h.value, 60),
            pagina: pad()
          });
        }).observe(ok, { attributes: true, attributeFilter: ['hidden'] });
      })(vms[i]);
    }

    /* Foto's: elke foto na de eerste telt een keer per paginabezoek. */
    var track = document.querySelector('[data-gal-track]');
    if (track && 'IntersectionObserver' in window) {
      var slides = [].slice.call(track.querySelectorAll('.gal__slide'));
      if (slides.length > 1) {
        var gezien = {};
        var prod = handleVan(location.pathname);
        var fio = new IntersectionObserver(function (lijst) {
          lijst.forEach(function (en) {
            if (!en.isIntersecting) return;
            var n = slides.indexOf(en.target);
            if (n < 1 || gezien[n]) return;
            gezien[n] = true;
            ev('tt_foto', { foto: n + 1, fotos: slides.length, product: prod, pagina: pad() });
          });
        }, { root: track, threshold: 0.6 });
        slides.forEach(function (sl) { fio.observe(sl); });
      }
    }

    /* Geen resultaten op een collectie- of zoekpagina. Alleen in de
       hoofdinhoud kijken: het menu bevat ook productlinks. */
    if (/\/collections\/|\/search/.test(location.pathname)) {
      var hoofd = document.querySelector('main') || document;
      if (!hoofd.querySelector('a[href*="/products/"]')) {
        ev('tt_geen_resultaten', {
          pagina: pad(),
          filters: (location.search || '').slice(0, 90)
        });
      }
    }
  });
})();
